import React from "react";
import TextField from "@mui/material/TextField";
import styled from "@emotion/styled";
import { InputAdornment } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate } from "react-router-dom";

const StyledTextField = styled(TextField)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export default function InvoicesCombobox({ label, selectedInvoiceID = null }) {
  const navigate = useNavigate();

  return (
    <StyledTextField
      disabled
      fullWidth
      margin="dense"
      size="small"
      label={label ? label : ""}
      value={selectedInvoiceID || ""}
      InputProps={{
        startAdornment: (
          <InputAdornment
            position="start"
            sx={{
              display: selectedInvoiceID != null ? "flex" : "none",
            }}
          >
            <IconButton
              onClick={() => navigate(`/invoices/${selectedInvoiceID}`)}
              edge="end"
            >
              {<LinkIcon />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
